import React from 'react';

import { formatNumber } from '../utils';

import config from './RepeatOrder.config';
import './RepeatOrder.style.less';

const RepeatOrder = ({
  intl: { formatMessage },
  orders,
  onSelect,
  selectedIndex,
  isGenesis,
}) => {
  if (orders && orders.length < 1) return null;
  return (
    <div id="repeatOrder">
      <div className="ro-title">
        {formatMessage({ id: 'comp.repeatOrder' })}
      </div>
      <div className="scroll-card">
        <div className="scroll-content">
          {orders.map((order, index) => {
            const { account } = order;
            let accountNumber = account;
            if (account.length > 12) {
              const prefix = account.substring(0, 7);
              const suffix = `•••${account.substring(
                account.length - 4,
                account.length,
              )}`;
              accountNumber = prefix + suffix;
            }

            const amount = isGenesis
              ? order.name
              : `Rp${formatNumber(order.amount)}`;

            return (
              <div
                className={`card ${selectedIndex === index ? 'active' : ''}`}
                key={order.id}
                onClick={onSelect(order, index)}
              >
                <img src={order.icon} alt={order.name} />
                <div className="card-content">
                  <span className="account">{accountNumber}</span>
                  <span className="amount">{amount}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

RepeatOrder.propTypes = config.propTypes;
RepeatOrder.defaultProps = config.defaultProps;
RepeatOrder.displayName = config.displayName;

export default RepeatOrder;
